import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserNotification } from '@models/user';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private _nots = new BehaviorSubject<UserNotification[]>([]);
  notifications = this._nots.asObservable();

  constructor() { }

  add(notifications: UserNotification[]) {
    let currentValue = this._nots.value;
    currentValue = currentValue.concat(notifications);
    this._nots.next(currentValue);
  }

  replace(notifications: UserNotification[]) {
    this._nots.next(notifications);
  }
  
  clean() {
    this._nots.next([]);
  }

  removeDevice(deviceId: string) {
    let currentValue = this._nots.value.filter((m) => m.id !== deviceId);
    this.replace(currentValue);
  }

  removeNotificationId(notificationId: string) {
    let currentValue = this._nots.value.filter((m) => m.notificationId !== notificationId);
    this.replace(currentValue);
  }

  get(): UserNotification[] {
    return this._nots.value;
  }
}